import { getPosition } from "../utils"
import store from "../store"

export default {
  init: function () {
    const t = this
    const bioSection = document.querySelector('[data-bio-section]')
    
    t.moveWrap = document.querySelector('[data-bio-more-wrap]')
    t.bioMore = document.querySelectorAll('[data-bio-more]')

    if (!bioSection) return
    
    t.showMoreInfo()
    
    t.backHideMore()
    
    t.slideToNext()
    
    t.offsetTopBioWrap()
  },
  
  backHideMore: function() {
    const t = this
    
    Array.from(document.querySelectorAll('[data-bio-link-close]')).forEach(el => {
      el.addEventListener('click', () => {
        t.hideToRight()
      })
    })
  },
  
  slideToNext: function() {
    const t = this
    
    Array.from(document.querySelectorAll('[data-bio-link-next]')).forEach(el => {
      el.addEventListener('click', e => {
        t.hideToRight()
        
        setTimeout(() => {
          t.openMoreInfo()
          t.displayExactMore(`tab-${(parseInt(e.target.closest('[data-bio-more]').getAttribute('data-bio-more').split('-')[1])) + 1}`)
        }, 400)
      })
    })
  },
  
  offsetTopBioWrap: function() {
    let t = this
    
    t.bioMoreOffset = getPosition(t.moveWrap)
    
    window.addEventListener('resize', () => {
      t.bioMoreOffset = getPosition(t.moveWrap)
    }, true)
  },
  
  displayExactMore: function(dataBioItem) {
    const t = this
    
    if(!store.getState().sniffer.isIE11) {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: t.bioMoreOffset.top
      })
    }
    
    document.querySelector(`[data-bio-more=${dataBioItem}]`).style.display = 'flex'
  },
  
  hideToRight: function() {
    const t = this
    
    t.moveWrap.style.right = '-110%'
  },
  
  hideSectionsMore: function() {
    const t = this

    Array.from(t.bioMore).forEach(el => {
      el.style.display = 'none'
    })
  },
  
  openMoreInfo: function() {
    const t = this
    
    t.hideSectionsMore()
    t.moveWrap.style.right = '0'
  },
  
  showMoreInfo: function() {
    const t = this
    
    const bioLinks = document.querySelectorAll('[data-bio-link]')
    
    Array.from(bioLinks).forEach(bioLink => {
      bioLink.addEventListener('click', e => {
        t.openMoreInfo()
        t.displayExactMore(e.target.closest('[data-bio]').getAttribute('data-bio'))
      })
    })
  },
}
